export enum ThemePreference {
    AUTO = "auto",
    DARK = "dark",
    LIGHT = "light",
}